export default __webpack_public_path__ + "static/media/content-img-3.b741a9fe.webp";